
import React from 'react';
import { UtensilsCrossed, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Clock } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const RestaurantLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: UtensilsCrossed,
      title: "Cardápio Digital",
      subtitle: "Veja nossos pratos especiais",
      url: "https://decidedigital.com.br/",
      bgColor: "bg-amber-500 hover:bg-amber-600"
    },
    {
      icon: Clock,
      title: "Delivery Online",
      subtitle: "Peça agora pelo app",
      url: "https://decidedigital.com.br/",
      bgColor: "bg-green-500 hover:bg-green-600"
    },
    {
      icon: MessageCircle,
      title: "Reservas WhatsApp",
      subtitle: "Reserve sua mesa",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20gostaria%20de%20fazer%20uma%20reserva!",
      bgColor: "bg-green-600 hover:bg-green-700"
    },
    {
      icon: Phone,
      title: "Telefone",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      bgColor: "bg-blue-500 hover:bg-blue-600"
    },
    {
      icon: Mail,
      title: "Contato",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      bgColor: "bg-purple-500 hover:bg-purple-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-orange-100 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Profile Section */}
        <div className="bg-white rounded-3xl p-6 shadow-xl mb-6 animate-fade-in">
          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center">
              <UtensilsCrossed className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Sabor & Tradição</h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              🍽️ Restaurante familiar com os melhores sabores da região. 
              Pratos tradicionais feitos com amor e ingredientes frescos.
            </p>
          </div>
        </div>

        {/* QR Code for Menu */}
        <div className="bg-white rounded-2xl p-4 shadow-md mb-6 text-center animate-scale-in">
          <p className="text-gray-700 text-sm mb-3 font-medium">📱 Cardápio Digital - Escaneie aqui:</p>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={120} />
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <social.icon className="w-5 h-5 text-amber-600" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-3">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-4 ${link.bgColor} rounded-2xl text-white shadow-lg transition-all duration-300 transform hover:scale-105 animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                  <link.icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Location Map */}
        <div className="bg-white rounded-2xl p-4 shadow-md mt-6 animate-fade-in">
          <p className="text-gray-700 text-sm mb-3 font-medium text-center">📍 Venha nos visitar:</p>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={16} />
        </div>

        {/* Hours */}
        <div className="bg-amber-500 rounded-2xl p-4 mt-4 text-white text-center animate-fade-in">
          <p className="font-semibold mb-1">🕐 Horário de Funcionamento</p>
          <p className="text-sm">Seg-Dom: 11h às 23h</p>
        </div>
      </div>
    </div>
  );
};

export default RestaurantLinktree;
